import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from '../components/layout/Sidebar';
import { Header } from '../components/layout/Header';
export function DashboardLayout() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  return <div className="min-h-screen bg-slate-50 flex" data-id="element-179">
      {/* Sidebar */}
      <Sidebar isOpen={isSidebarOpen} setIsOpen={setIsSidebarOpen} data-id="element-180" />

      {/* Main Content Wrapper */}
      <div className={`flex-1 flex flex-col transition-all duration-300 ${isSidebarOpen ? 'ml-64' : 'ml-20'}`} data-id="element-181">
        <Header data-id="element-182" />

        <main className="flex-1 p-6 overflow-auto" data-id="element-183">
          <div className="max-w-7xl mx-auto" data-id="element-184">
            <Outlet data-id="element-185" />
          </div>
        </main>
      </div>
    </div>;
}